import { axiosInstance } from '@configs/axios/axiosInstance';

import type {
  PostInstructorRequestBody,
  PostInstructorRequestResponse,
} from './postInstructorRequest.types';

export async function postInstructorRequest(
  customerId: string,
  instructorId: string,
  body: PostInstructorRequestBody
): Promise<PostInstructorRequestResponse> {
  const response = await axiosInstance.post<PostInstructorRequestResponse>(
    `/instructors/${encodeURIComponent(instructorId)}/requests`,
    body,
    {
      headers: {
        'X-Customer-Id': customerId,
      },
    }
  );
  return response.data;
}
